import { render, staticRenderFns } from "./RestoreInvoice.vue?vue&type=template&id=48fc9abd&"
import script from "./RestoreInvoice.vue?vue&type=script&lang=js&"
export * from "./RestoreInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports